var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumnCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.55 20.5906C11.76 20.5906 10.89 20.3106 10.02 19.7606L7.1 17.9306C6.9 17.8106 6.67 17.7406 6.44 17.7406H5C2.58 17.7406 1.25 16.4106 1.25 13.9906V9.99059C1.25 7.57059 2.58 6.24059 5 6.24059H6.43C6.66 6.24059 6.89 6.17059 7.09 6.05059L10.01 4.22059C11.47 3.31059 12.89 3.14059 14.01 3.76059C15.13 4.38059 15.74 5.67059 15.74 7.40059V16.5706C15.74 18.2906 15.12 19.5906 14.01 20.2106C13.57 20.4706 13.07 20.5906 12.55 20.5906ZM5 7.75059C3.42 7.75059 2.75 8.42059 2.75 10.0006V14.0006C2.75 15.5806 3.42 16.2506 5 16.2506H6.43C6.95 16.2506 7.45 16.3906 7.89 16.6706L10.81 18.5006C11.78 19.1006 12.68 19.2606 13.29 18.9206C13.9 18.5806 14.25 17.7306 14.25 16.6006V7.41059C14.25 6.27059 13.9 5.42059 13.29 5.09059C12.68 4.75059 11.77 4.90059 10.81 5.51059L7.88 7.33059C7.45 7.61059 6.94 7.75059 6.43 7.75059H5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.7095C21.81 14.7095 21.62 14.6395 21.47 14.4895L17.51 10.5295C17.22 10.2395 17.22 9.75945 17.51 9.46945C17.8 9.17945 18.28 9.17945 18.57 9.46945L22.53 13.4295C22.82 13.7195 22.82 14.1995 22.53 14.4895C22.38 14.6295 22.19 14.7095 22 14.7095Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 14.7505C17.8099 14.7505 17.6199 14.6805 17.4699 14.5305C17.1799 14.2405 17.1799 13.7605 17.4699 13.4705L21.4299 9.51047C21.7199 9.22047 22.1999 9.22047 22.4899 9.51047C22.7799 9.80047 22.7799 10.2805 22.4899 10.5705L18.5299 14.5305C18.3799 14.6805 18.1899 14.7505 17.9999 14.7505Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumnCross);
export default __webpack_public_path__ + "static/media/volumn-cross.78ef041612d0a0dfb59ecaf0e77d1009.svg";
export { ForwardRef as ReactComponent };